// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3uYW_","header":"Messages_header__3RH6s"};